// Google Analytics gtag utility functions

// Declare gtag function for ESLint
/* global gtag */

// Helper function to delay opening a URL until a gtag event is sent.
// Call it in response to an action that should navigate to a URL.
export function gtagSendEvent(url) {
  var callback = function () {
    if (typeof url === 'string') {
      window.location = url;
    }
  };
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'ad_impression', {
      'event_callback': callback,
      'event_timeout': 2000,
      // <event_parameters>
    });
  }
  return false;
}

// Track PWA download/install attempts
export function trackPWADownload(source) {
  console.log('🎯 PWA Download attempt:', source);
  
  // Track with Google Analytics (gtag)
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'pwa_download_attempt', {
      event_category: 'PWA Installation',
      event_label: source,
      timestamp: Date.now()
    });
    console.log('✅ Google Analytics event sent');
  }
  
  // Track with Firebase Analytics - use the same pattern as usePageTracking
  if (typeof window !== 'undefined') {
    import('../firebase').then(({ analytics }) => {
      if (analytics) {
        import('firebase/analytics').then(({ logEvent }) => {
          try {
            logEvent(analytics, 'pwa_download_attempt', {
              source: source,
              timestamp: Date.now()
            });
            console.log('✅ Firebase Analytics event sent');
          } catch (error) {
            console.warn('❌ Firebase Analytics tracking failed:', error);
          }
        });
      } else {
        console.warn('❌ Firebase Analytics not initialized yet');
        // Retry after a short delay
        setTimeout(() => {
          import('../firebase').then(({ analytics }) => {
            if (analytics) {
              import('firebase/analytics').then(({ logEvent }) => {
                try {
                  logEvent(analytics, 'pwa_download_attempt', {
                    source: source,
                    timestamp: Date.now()
                  });
                  console.log('✅ Firebase Analytics event sent (retry)');
                } catch (error) {
                  console.warn('❌ Firebase Analytics retry failed:', error);
                }
              });
            }
          });
        }, 2000);
      }
    });
  }
}

// Track PWA install events
export function trackPWAInstall(outcome, source) {
  console.log('🎯 PWA Install outcome:', outcome, 'from', source);
  
  // Track with Google Analytics (gtag)
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'pwa_install', {
      event_category: 'PWA Installation',
      event_label: source,
      outcome: outcome, // 'accepted', 'dismissed', or 'installed'
      timestamp: Date.now()
    });
    console.log('✅ Google Analytics event sent');
  }
  
  // Track with Firebase Analytics - use the same pattern as usePageTracking
  if (typeof window !== 'undefined') {
    import('../firebase').then(({ analytics }) => {
      if (analytics) {
        import('firebase/analytics').then(({ logEvent }) => {
          try {
            logEvent(analytics, 'pwa_install', {
              outcome: outcome,
              source: source,
              timestamp: Date.now()
            });
            console.log('✅ Firebase Analytics event sent');
          } catch (error) {
            console.warn('❌ Firebase Analytics tracking failed:', error);
          }
        });
      } else {
        console.warn('❌ Firebase Analytics not initialized yet');
        // Retry after a short delay
        setTimeout(() => {
          import('../firebase').then(({ analytics }) => {
            if (analytics) {
              import('firebase/analytics').then(({ logEvent }) => {
                try {
                  logEvent(analytics, 'pwa_install', {
                    outcome: outcome,
                    source: source,
                    timestamp: Date.now()
                  });
                  console.log('✅ Firebase Analytics event sent (retry)');
                } catch (error) {
                  console.warn('❌ Firebase Analytics retry failed:', error);
                }
              });
            }
          });
        }, 2000);
      }
    });
  }
}

// Track guaranteed PWA installation (only fires when app is actually installed)
export function trackPWAInstallationConfirmed(source = 'unknown') {
  console.log('🎯 PWA Installation CONFIRMED:', source);
  
  // Track with Google Analytics (gtag)
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'pwa_installation_confirmed', {
      event_category: 'PWA Installation',
      event_label: source,
      installation_status: 'successful',
      timestamp: Date.now()
    });
    console.log('✅ Google Analytics installation confirmed event sent');
  }
  
  // Track with Firebase Analytics
  if (typeof window !== 'undefined') {
    import('../firebase').then(({ analytics }) => {
      if (analytics) {
        import('firebase/analytics').then(({ logEvent }) => {
          try {
            logEvent(analytics, 'pwa_installation_confirmed', {
              source: source,
              installation_status: 'successful',
              timestamp: Date.now()
            });
            console.log('✅ Firebase Analytics installation confirmed event sent');
          } catch (error) {
            console.warn('❌ Firebase Analytics installation tracking failed:', error);
          }
        });
      }
    });
  }
}

// Test function to verify PWA tracking
export function testPWATracking() {
  console.log('🧪 Testing PWA tracking functions...');
  
  // Test download tracking
  trackPWADownload('test_localhost');
  
  // Test install tracking
  trackPWAInstall('accepted', 'test_localhost');
  trackPWAInstall('dismissed', 'test_localhost');
  trackPWAInstallationConfirmed('test_localhost');
  
  console.log('🧪 PWA tracking tests completed. Check console for results.');
}

// Helper function to delay opening a URL until a gtag first_visit event is sent.
export function gtagSendFirstVisitEvent(url) {
  var callback = function () {
    if (typeof url === 'string') {
      window.location = url;
    }
  };
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'first_visit', {
      'event_callback': callback,
      'event_timeout': 2000,
      // <event_parameters>
    });
  }
  return false;
}

// Track ad impression event
export function trackAdImpression() {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'ad_impression', {
      // <event_parameters>
    });
  }
}

// Track first visit event
export function trackFirstVisit() {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'first_visit', {
      // <event_parameters>
    });
  }
}

